import { render, staticRenderFns } from "./AutomationCampaignPanelGroupInfo.vue?vue&type=template&id=4a6887fb&scoped=true"
import script from "./AutomationCampaignPanelGroupInfo.vue?vue&type=script&lang=js"
export * from "./AutomationCampaignPanelGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./AutomationCampaignPanelGroupInfo.vue?vue&type=style&index=0&id=4a6887fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6887fb",
  null
  
)

export default component.exports